import { styled, Typography, TextareaAutosize } from "@mui/material";

export {
  StyledContainer,
  StyledTitle,
  StyledTitleNumber,
  StyledTitleContainer,
  StyledContentContainer,
  StyledHint,
} from "../Common.styles";

export const StyledTextarea = styled(TextareaAutosize)(({ theme }) => ({
  minHeight: "116px",
  width: "100%",
  padding: "12px",
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "24px",
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: "8px",
  fontFamily: theme.typography.fontFamily,
  resize: "vertical",
  "&:focus": {
    outline: "none",
    borderColor: theme.palette.primary.main,
    borderWidth: "2px",
  },
  "&::placeholder": {
    color: theme.palette.text.disabled,
  },
}));

export const StyledCharCount = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: "400",
  color: theme.palette.text.secondary,
  lineHeight: "20px",
  marginLeft: "auto",
}));
